import { jsxs, jsx, Fragment } from "react/jsx-runtime";
import React__default from "react";
import { Box, Paragraph, DetailedIconCalculatorMoney, Text, Flex, Popper, Popover, Heading } from "@zillow/constellation";
import { commaSeparateNumber } from "../../utils/zhl-calculator.esm.js";
import { useLastValidCashOutRefinanceValues, OUTPUTS, cashOutputs, getResult } from "./CashOutRefinanceCalculator.utils.esm.js";
const monthlyPaymentPopover = /* @__PURE__ */ jsx(Popover, { header: /* @__PURE__ */ jsx(Heading, { level: 6, children: "New monthly payment" }), body: /* @__PURE__ */ jsx(React__default.Fragment, { children: /* @__PURE__ */ jsx(Paragraph, { children: "This is the principal and interest payment based on your new loan balance. Your monthly payment may also include property taxes, homeowners insurance and mortgage insurance premiums, which are not shown in this estimate." }) }) });
const CashOutRefinanceContent = () => {
  const lastValidCashOutRefinanceValues = useLastValidCashOutRefinanceValues();
  const {
    EstimatedMaxCashOutAmount,
    combinedLoanToValue,
    adjustedCashOutEstimate
  } = lastValidCashOutRefinanceValues.calculations;
  return EstimatedMaxCashOutAmount <= 0 || combinedLoanToValue > 80 || adjustedCashOutEstimate <= 0 ? /* @__PURE__ */ jsxs(Box, { sx: {
    display: "flex",
    justifyContent: "center",
    flexDirection: "column",
    alignItems: "center",
    margin: "$spacing.md",
    background: "$colors.backgroundBlue",
    height: "300px"
  }, children: [
    /* @__PURE__ */ jsx(Box, { sx: {
      svg: {
        height: "75px!important",
        width: "75px!important"
      }
    }, children: /* @__PURE__ */ jsx(Paragraph, { fontType: "h1", marginTop: "md", children: /* @__PURE__ */ jsx(DetailedIconCalculatorMoney, {}) }) }),
    /* @__PURE__ */ jsx(Text, { marginTop: "md", fontType: "h5", as: "p", "font-weight": "normal", textAlign: "center", children: "You need more home equity to cash-out." }),
    /* @__PURE__ */ jsx(Box, { sx: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      margin: "$spacing.sm",
      maxWidth: "70%"
    }, children: /* @__PURE__ */ jsx(Text, { textAlign: "center", children: "Try paying down more of your principal to lower your loan-to-value (LTV). This will help you build up enough home equity for a cash-out refinance." }) })
  ] }) : /* @__PURE__ */ jsx(Box, { children: /* @__PURE__ */ jsxs(Flex, { flex: "1", alignItems: "center", display: "flex", justifyContent: "center", flexDirection: "column", marginTop: "lg", "aria-live": "polite", "aria-atomic": "true", width: "100%", children: [
    /* @__PURE__ */ jsx(Text, { fontType: "h4", as: "p", "font-weight": "Normal", children: "Estimated max cash-out amount" }),
    /* @__PURE__ */ jsxs(Text, { fontColor: "green500", fontType: "h3", margin: "sm", children: [
      "$",
      commaSeparateNumber(lastValidCashOutRefinanceValues.calculations.EstimatedMaxCashOutAmount)
    ] }),
    OUTPUTS.map((label, index) => /* @__PURE__ */ jsxs(Box, { sx: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      paddingBottom: "$spacing.sm",
      marginBottom: "$spacing.sm",
      borderBottom: index !== OUTPUTS.length - 1 ? `1px solid $colors.coolGray400` : null,
      width: "70%"
    }, last: index === OUTPUTS.length - 1, children: [
      /* @__PURE__ */ jsx(Paragraph, { children: /* @__PURE__ */ jsx(Box, { as: "span", sx: {
        display: "flex",
        flexDirection: "row",
        marginBottom: "$spacing.xxs",
        gap: "$spacing.xxs"
      }, children: label === cashOutputs.newMonthlyPayment && /* @__PURE__ */ jsxs(Fragment, { children: [
        label,
        /* @__PURE__ */ jsx(Popper, { style: {
          alignSelf: "center"
        }, triggered: monthlyPaymentPopover })
      ] }) || label }) }),
      /* @__PURE__ */ jsx(Text, { fontType: "h4", children: getResult(label, lastValidCashOutRefinanceValues) })
    ] }, index))
  ] }) });
};
export {
  CashOutRefinanceContent as default
};
